import { dynamicDatePickerTestIds } from '../TestsIds';
import { DynamicDatePicker, IDynamicDatePickerProps } from './DynamicDatePicker';

export { dynamicDatePickerTestIds as testIds };
export type { IDynamicDatePickerProps };
export default DynamicDatePicker;
